import { DisplayValue } from '@adaptiva/core/common';
import { EDeletionState, EPublicationState, HousekeepingProperties, MetadataSerialization } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseAuthoringPropertiesComponent } from '../base-authoring-component';

@Component({
	standalone: false,
	selector: 'ada-housekeeping-properties',
	templateUrl: './housekeeping-properties.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class HousekeepingPropertiesComponent extends BaseAuthoringPropertiesComponent<HousekeepingProperties> {

	public propertyConstructor: MetadataSerialization.Deserializable<HousekeepingProperties> = HousekeepingProperties;

	public readonly publicationStateOptions: DisplayValue[] = [
		{ display: 'Published', value: EPublicationState.PUBLISHED },
		{ display: 'Old Published', value: EPublicationState.OLD_PUBLISHED },
		{ display: 'Not Published', value: EPublicationState.NOT_PUBLISHED }
	];

	public readonly deletedStateOptions: DisplayValue[] = [
		{ display: 'Not Deleted', value: EDeletionState.NOT_DELETED },
		{ display: 'Marked For Deletion', value: EDeletionState.MARKED_FOR_DELETION },
		{ display: 'Marked For Undeletion', value: EDeletionState.MARKED_FOR_UNDELETION },
		{ display: 'Deleted', value: EDeletionState.DELETED }
	];

}
